import {useQuery} from '@tanstack/react-query';
import {getApiKeys, VerdocsEndpoint} from '@verdocs/js-sdk';

export const useApiKeys = (organizationId: string | undefined) =>
  useQuery({
    queryKey: ['api_keys', organizationId],
    queryFn: () => (organizationId ? getApiKeys(VerdocsEndpoint.getDefault()) : null),
  });
